<template>
  <div class='tablePage'>
    <el-table
      v-loading='loading'
      ref='multipleTable'
      :data='tableData'
      tooltip-effect='dark'
      style='width: 100%'
      :header-cell-style='headCellStyle'
      :height='tableHeight'
      @selection-change='handleSelectionChange'
      stripe
    >
      <el-table-column type='selection' width='50' />
      <el-table-column v-if='isSys' prop='scopeName' :label="$t('public.table_scope')" show-overflow-tooltip />
      <el-table-column prop='name' :label="$t('device.gateway_name')" show-overflow-tooltip>
        <template #default='{ row }'>
          <DeviceCode :device='row'>
            <template #icon='{device}'>
              <i v-icon:theme="['gatewayTypeConvert', device.type]" v-if='!$slots.icon'></i>
            </template>
            <template #name='{device}'>
              <el-popover placement='top-start' width='auto' trigger='hover'>
                <v-popoer :rowData='device' :typeWay='$attrs.sensorWay' />
                <span slot='reference' :class="{'bolder':device.status===ENUM_SENSOR_STATUS.OFFLINE}">
                              {{ device.name }}
                          </span>
              </el-popover>
            </template>
          </DeviceCode>
          <!--                    <i v-icon:theme="['gatewayTypeConvert', row.type]"></i>-->
          <!--                    <i v-icon:theme="['equiStatusConvert', row.status]"></i>-->
          <!--                    <i v-icon:theme="['configStatusConvert', row.config_status]"></i>-->
        </template>
      </el-table-column>

      <el-table-column prop='mac' label='mac' show-overflow-tooltip />
      <el-table-column prop='updateTime' :label="$t('public.update_time')" show-overflow-tooltip>
        <template #default='{row}'>
          {{ $timetransition(row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column prop='optare' fixed='right' :label="$t('public.table_operation')" width='160' align='center'>
        <template #default='{ row }'>
          <el-button type='text' size='small' v-for='item in optareBtn' :key='item.id' :title='$t(item.title)'
                     :icon='item.icon' @click='handle(item.method, row)'></el-button>
          <!-- v-has="item.vHas" -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import prover from '../components/Proper.vue'
import DeviceCode from '@/pages/equipment/publicCom/DeviceCode.vue'
import { ENUM_DEVICE_STATUS } from '@/common/enum/forward/device'
import { getIsSys } from '@/utils/permission'

export default {
  props: ['loading', 'tableData'],
  computed: {
    ENUM_SENSOR_STATUS () {
      return ENUM_DEVICE_STATUS
    },
    isSys () {
      return getIsSys()
    }
  },
  components: {
    DeviceCode,
    'v-popoer': prover
  },
  data () {
    return {

      tableHeight: '100%',
      optareBtn: [
        {
          id: 1,
          title: $t('public.stop'),
          icon: 'el-icon-video-pause',
          vHas: [],
          method: 'stopUseFn'
        },
        {
          id: 2,
          title: $t('public.config'),
          icon: 'el-icon-setting',
          vHas: [],
          method: 'configFn'
        },
        {
          id: 4,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        }
      ]
    }
  },
  methods: {
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    handle (method, row) {
      this.$emit(method, row)
    }
  }
}
</script>

<style lang='scss' scoped>
.tablePage {
  height: calc(100% - 60px);
}
</style>
